/**
 * Displays API or validation error message for Create Administrators.
 */

import { observer } from 'mobx-react-lite';

import Card from '../../../../../components/layouts/card/card';
import FontBody2 from '../../../../../components/fonts/font-body2/font-body2';
import { FONT_COLOR, FONT_VARIANT } from '../../../../../components/fonts/font-props';
import createAdministratorsStore from '../stores/create-administrators-store';

const CreateAdministratorsErrorBanner: React.FC = observer(() => {
    const store = createAdministratorsStore;

    if (!store.errorMessage) {
        return null;
    }

    return (
        <div className="create-administrators-page__error">
            <Card isExpandable={false}>
                <FontBody2 color={FONT_COLOR.ACCENT3} variant={[FONT_VARIANT.BOLD]}>
                    {store.errorMessage}
                </FontBody2>
            </Card>
        </div>
    );
});

export default CreateAdministratorsErrorBanner;
